import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang, tField } from "../lib/LanguageContext";
import { api, imageUrl } from "../lib/api";

export default function PressSection() {
    const { lang } = useLang();
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/press").then((r) => setItems(r.data)).catch(() => setItems([]));
    }, []);

    if (!items.length) return null;

    const heading = {
        al: "Të Përmendur Në",
        en: "Featured In",
        it: "Presenti Su",
        de: "Erwähnt In",
    }[lang] || "Featured In";

    return (
        <section data-testid="press-section" className="py-16 md:py-20 px-6 md:px-12 bg-white border-y border-[#E5E0D8]/60">
            <div className="max-w-6xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-10"
                >
                    <span className="text-xs uppercase tracking-[0.4em] text-[#CBA871]">{heading}</span>
                </motion.div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 md:gap-10 items-center justify-items-center">
                    {items.map((p, i) => {
                        const card = (
                            <div className="group flex flex-col items-center text-center">
                                {p.logo ? (
                                    <img
                                        decoding="async"
                                        loading="lazy"
                                        src={imageUrl(p.logo)}
                                        alt={p.name}
                                        className="h-10 md:h-12 w-auto object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                                    />
                                ) : (
                                    <span className="font-serif text-xl text-[#0F3A59]/70 group-hover:text-[#0F3A59] transition-colors">
                                        {p.name}
                                    </span>
                                )}
                                {tField(p, "quote", lang) && (
                                    <p className="text-xs text-[#1C1C1C]/55 font-light italic mt-3 line-clamp-2 max-w-[180px]">
                                        “{tField(p, "quote", lang)}”
                                    </p>
                                )}
                            </div>
                        );
                        return (
                            <motion.div
                                key={p.id}
                                initial={{ opacity: 0, y: 15 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.07, duration: 0.4 }}
                                data-testid={`press-${p.id}`}
                            >
                                {p.url ? (
                                    <a href={p.url} target="_blank" rel="noreferrer" aria-label={p.name}>
                                        {card}
                                    </a>
                                ) : (
                                    card
                                )}
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
